<template>
  <div class="app">
    <nav class="navbar">
      <div class="container">
        <router-link to="/" class="logo">
          <img src="/images/logo.png" alt="公司 LOGO" class="logo-image">
        </router-link>
        <div class="nav-links">
          <router-link to="/">首页</router-link>
          <div class="dropdown">
            <router-link to="/products" class="dropdown-trigger">
              产品
              <span class="dropdown-arrow">▼</span>
            </router-link>
            <div class="dropdown-menu">
              <router-link to="/products/server">浪潮X86服务器</router-link>
              <router-link to="/products/innovation">浪潮信创服务器</router-link>
              <router-link to="/products/storage">浪潮存储</router-link>
              <router-link to="/products/xsky">XSKY分布式存储</router-link>
              <router-link to="/products/lenovo">联想服务器</router-link>
            </div>
          </div>
          <router-link to="/solutions">解决方案</router-link>
          <router-link to="/services">服务</router-link>
          <router-link to="/about">关于我们</router-link>
          <router-link to="/contact">联系我们</router-link>
        </div>
      </div>
    </nav>

    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <footer class="footer">
      <div class="container">
        <p><img src="/images/beian.png" alt="备案图标" class="beian-icon">京公网安备11010802045567号   京ICP备2025115783号<br>
          &copy;2025 北京杰创诚通科技有限公司. 版权所有.</p>
      </div>
    </footer>
  </div>
</template>

<style>
:root {
  --primary-color: #2c3e50;
  --secondary-color: #3498db;
  --background-color: #f8f9fa;
  --text-color: #333;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.6;
  color: var(--text-color);
  background-color: var(--background-color);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.navbar {
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.logo {
  text-decoration: none;
  background: white;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.logo-image {
  height: 50px;
  width: auto;
  display: block;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-links a {
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: var(--secondary-color);
}

.footer {
  background: var(--primary-color);
  color: white;
  padding: 2rem 0;
  text-align: center;
  margin-top: 4rem;
}

.beian-icon {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  margin-right: 0.3em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  transition: color 0.3s;
}

.dropdown-arrow {
  font-size: 0.8rem;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  min-width: 160px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: 1000;
  padding: 0.5rem 0;
}

.dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}

.dropdown-menu a {
  display: block;
  padding: 0.7rem 1.5rem;
  color: var(--text-color);
  text-decoration: none;
  transition: background-color 0.3s;
  text-align: center;
  white-space: nowrap;
}

.dropdown-menu a:hover {
  background-color: #f5f5f5;
  color: var(--secondary-color);
}
</style>